/* =====================================================================
 * Geburtsposter / Namensposter Editor (PROJ-12)
 * =====================================================================
 * Reines Text-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = kalender-poster.js (State/Live-Preview, Groessen-/Frame-Picker aus
 * target_product.variants, Cart-Add).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderGeburtsposter() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw-Groessen, Auto-Fit). Aendert sich der Server, muss dieser Block
 * mitgezogen werden - Werte bewusst identisch.
 *
 * Layout: grosses Serif-Initial (Pastell-Preset) mittig, Name in Script
 * quer darueber (z-index UEBER dem Initial, Playbook §3), unten optionale
 * Geburtsdaten-Zeile. Alle 4 Datenfelder leer = Namensposter-Layout
 * (Zeile entfaellt, Namensblock rueckt auf 50% = vertikal zentriert).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.GBP_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 700 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }
  /* Initial-Groesse pro Stil: verspielt (Parlare) deutlich kleiner -
   * die Glyphen sind riesig gezeichnet (Dominik 19.07.: Parlare bleibt,
   * nur kleiner; Hoehen-Clamp in gbpFit faengt Ausreisser wie L ab). */
  var INITIAL_SIZE = { modern: 82, elegant: 82, verspielt: 48 };

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId, mode;
  var state = {
    fstyle: { letter: 'modern', name: 'verspielt' },
    name: 'Emilia',
    date: '',              // YYYY-MM-DD (Date-Input) oder ''
    time: '',              // HH:MM (Time-Input) oder ''
    weight: '',
    height: '',
    initial_color: '#e3d4bd',   // Preset Beige = neutralster Default
    c_name: '#28292d',
    c_data: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  function gbpPad(n) { return (n < 10 ? '0' : '') + n; }

  /* Datenzeile komponieren - nur gefuellte Felder, Trenner nur zwischen
   * vorhandenen (AK-Format: 26.04.2022 | 04:40 Uhr | 3160 Gramm | 51 cm).
   * Der komponierte String geht 1:1 als data_line an den Server -> der
   * Druck zeigt exakt die Editor-Zeile. */
  function composeDataLine() {
    var parts = [];
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(state.date || '');
    if (m) parts.push(m[3] + '.' + m[2] + '.' + m[1]);
    if (state.time && /^\d{2}:\d{2}/.test(state.time)) parts.push(state.time.slice(0, 5) + ' Uhr');
    var w = (state.weight || '').trim();
    if (w) parts.push(/^[\d.,]+$/.test(w) ? w + ' Gramm' : w);
    var h = (state.height || '').trim();
    if (h) parts.push(/^[\d.,]+$/.test(h) ? h + ' cm' : h);
    return parts.join(' | ');
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function gbpText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function gbpFit(el, maxPct) {
    if (!el) return;
    var availW = stage.clientWidth * (maxPct / 100);
    // Hoehen-Clamp zusaetzlich zur Breite: hohe schmale Glyphen (Parlare-L)
    // passen sonst in die Breite, ragen aber vertikal ueber das Poster.
    var availH = stage.clientHeight * 0.86;
    var guard = 0;
    while ((el.scrollWidth > availW || el.scrollHeight > availH) && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderGeburtsposter() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var name = (state.name || '').trim();
    var dataLine = composeDataLine();
    // Namensblock: mit Datenzeile leicht nach oben (46%), ohne = zentriert (50%)
    var blockY = dataLine ? 46 : 50;

    // ---- Grosses Initial (Serif, Pastell-Preset, HINTER dem Script-Namen) ----
    var elInitial = null;
    if (name) {
      elInitial = gbpText(grid, {
        content: name.charAt(0).toUpperCase(),
        x: 50, y: blockY, font: pwFont(state.fstyle.letter).font, weight: pwFont(state.fstyle.letter).weight,
        size: INITIAL_SIZE[state.fstyle.letter] || 82,
        color: state.initial_color, lh: 1
      });
      if (elInitial) elInitial.style.zIndex = 4;
    }

    // ---- Name in Script QUER UEBER dem Initial (z-index, nicht Position!) ----
    var elName = null;
    if (name) {
      elName = gbpText(grid, {
        content: name.toLowerCase(),
        x: 50, y: blockY + 4, font: pwFont(state.fstyle.name).font, weight: pwFont(state.fstyle.name).weight, size: 13,
        color: state.c_name || INK, lh: 1
      });
      if (elName) elName.style.zIndex = 5;
    }

    // ---- Optionale Geburtsdaten-Zeile unten ----
    var elData = gbpText(grid, {
      content: dataLine, x: 50, y: 90, font: SANS, weight: 500, size: 2.3,
      color: state.c_data || INK, spacing: '0.18em'
    });

    stage.innerHTML = '';
    stage.appendChild(grid);

    // Fit erst nach Font-Load - sonst misst er die Fallback-Schrift
    // (Parlare laedt via Typekit) und der Clamp greift nicht.
    var fitReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    fitReady.then(function () {
      gbpFit(elInitial, 82);
      gbpFit(elName, 84);
      gbpFit(elData, 88);
    });
  }

  /* ===================================================================
   * Eingaben: Name, Datum/Uhrzeit/Gewicht/Groesse, Farben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
    el.addEventListener('change', function () { state[key] = el.value; render(); });
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.gbp-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPresetSwatches() {
    var swatches = root.querySelectorAll('.gbp-preset[data-color]');
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (x) { x.classList.remove('current'); });
        s.classList.add('current');
        state.initial_color = s.getAttribute('data-color');
        render();
      });
    });
    var active = root.querySelector('.gbp-preset.current[data-color]');
    if (active) state.initial_color = active.getAttribute('data-color');
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.gbp-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Kalender-/Fotoposter-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.gbp-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('gbp-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster kalender-poster.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('gbp-cart-btn-' + sectionId);
    var name = (state.name || '').trim();
    if (!name) { alert('Bitte gib einen Namen ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);
        var dataLine = composeDataLine();

        var payload = {
          product: 'geburtsposter',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          name: name,
          data_line: dataLine,
          initial_color: state.initial_color,
          c_name: state.c_name || INK,
          c_data: state.c_data || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/geburtsposter/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/geburtsposter/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Name': name,
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_Stil Buchstabe': PW_LABEL[state.fstyle.letter] || 'Modern',
          '_Stil Name': PW_LABEL[state.fstyle.name] || 'Verspielt',
          '_produkt': 'geburtsposter'
        };
        if (dataLine) props['_Geburtsdaten'] = dataLine;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[geburtsposter] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.gbp-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    mode = root.dataset.mode || 'geburtsposter';
    stage = document.getElementById('gbp-stage-' + sectionId);

    bindField('gbp-name', 'name');
    bindField('gbp-date', 'date');
    bindField('gbp-time', 'time');
    bindField('gbp-weight', 'weight');
    bindField('gbp-height', 'height');
    initStylePickers();
    initColorPickers();
    initPresetSwatches();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('gbp-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
